import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { translate } from '../../Services/translation';
import {
  submitDiscountCode,
  deleteDiscountCode,
  setDiscountCode,
  submitError,
} from '../../Actions/Checkout.action';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import Chip from '../Chip';
import styled from 'styled-components';
import { getColor } from '../../styling/mixins/colors';
import Input from '../Inputs/Input';
import Button from '../Button';
import { breakpoint } from '../../styling/mixins/breakpoints';
import CheckoutDiscountCollapsible from './Checkout.DiscountCollapsible';
import CheckoutSection from './utils/Checkout.Section';

const StyledDiscountWrapper = styled.div`
  margin: 1.6rem 0;
  display: flex;
  gap: 1rem;

  .title {
    cursor: pointer;
    text-decoration: underline;
    color: ${getColor('gray', 600)};    
    text-underline-position: under;
  }

  .label-wrapper {
    display: flex;
    gap: 2.0rem;
  }

  .input-wrapper {
    flex: 1;
    border: none;
  }

  .input {
    padding: 1.2rem;
    max-width: 237px;
    max-height: 32px;
    border: 1px solid ${getColor('grey', 200)};
  }

  .checkout__used-discount-codes {
    display: flex;
    gap: 0.8rem;
    height: fit-content;
  }

  button {
    min-width: 101px;
    max-height: 32px;
    background-color: #000000;
    ${breakpoint('large')} {
      margin-top: 0;
    };
  }
`;

const Discount = () => {
  const dispatch = useDispatch();
  const { payload, errors = {} } = useTypedSelector((state) => state.checkout);
  const { usedDiscountCodes } = payload;
  const [inputDiscountCode, setInputDiscountCode] = useState('');
  const [showDiscountInput, setShowDiscountInput] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (errors && !errors['discountCode']?.length) {
      setInputDiscountCode('');
    }
  }, [errors]);

  const submitDiscount = async (code) => {
    setIsLoading(true);
    await dispatch(setDiscountCode(code));
    await dispatch(submitDiscountCode());
    setIsLoading(false);
  };

  const onChange = (code) => {
    setInputDiscountCode(code);
    if (errors['discountCode']?.length > 0 && !code.length) {
      dispatch(
        submitError({
          modelState: {
            discountCode: [],
          },
        })
      );
    }
  };

  return (
    <CheckoutSection>
      <CheckoutDiscountCollapsible isOpen={false}>
        <StyledDiscountWrapper>
          {!showDiscountInput && (
            <a className="title" onClick={() => setShowDiscountInput(true)}>
              {translate('checkout.usecampaigncode')}
            </a>
          )}
          {showDiscountInput && (
            <div className="label-wrapper">
              <label className="input-wrapper" htmlFor="checkout__discount">
                <Input
                  type="text"
                  id="checkout__discount"
                  className="input"
                  onBlur={() => !inputDiscountCode}
                  value={inputDiscountCode}
                  onKeyDown={(e) =>
                    e.key == 'Enter' && submitDiscount(inputDiscountCode)
                  }
                  placeholder={translate('checkout.fillcampaigncode')}
                  onChange={(e) => onChange(e.target.value)}
                  disabled={isLoading}
                  message={
                    errors['discountCode']?.length > 0
                      ? errors['discountCode'][0]
                      : null
                  }
                  inputState={
                    errors['discountCode']?.length > 0 ? 'error' : 'default'
                  }
                />
              </label>
              <Button
                btnType="primary"
                onClick={() => submitDiscount(inputDiscountCode)}
                disabled={!inputDiscountCode || isLoading}
                className='mt-0'
              >
                {translate('checkout.discount.submit')}
              </Button>
            </div>
          )}
          {usedDiscountCodes && (
            <div className="checkout__used-discount-codes">
              {usedDiscountCodes.map((code) => (
                <Chip
                  key={'used-discount-code-' + code}
                  onDeleteClick={() => dispatch(deleteDiscountCode(code))}
                >
                  {code}
                </Chip>
              ))}
            </div>
          )}
        </StyledDiscountWrapper>
      </CheckoutDiscountCollapsible>
    </CheckoutSection>
  );
};

export default Discount;
